import { OrderingFormFields } from '@/components/question/forms/ordering/OrderingForm';
import { useObjectUrls } from '@/data/hook/shared/useObjectUrls';
import { DNDOrdenationQuestion } from '@/models/Question';
import adapterOrderingForm from '@/utils/questions/adapterOrderingForm';

export function useOrderingPreviewQuestion(
  fields: OrderingFormFields,
): DNDOrdenationQuestion {
  const files = (fields.orderingItems ?? [])
    .map(item => item.mediaFile)
    .filter((mediaFile): mediaFile is File => mediaFile instanceof File);

  const urlByFile = useObjectUrls(files);

  return adapterOrderingForm(fields, mediaFile => {
    if (mediaFile instanceof File) {
      return urlByFile.get(mediaFile) ?? null;
    }
    return typeof mediaFile === 'string' ? mediaFile : null;
  });
}
